// extracted by mini-css-extract-plugin
export default {"mainLayout":"LandingPage_mainLayout__t43FY"};